import { useState, useEffect } from 'react';
import { MOBILE_BREAKPOINT } from '../constants';

/**
 * Detects if mobile layout should be used based on:
 * 1. Touch capability + narrow viewport (actual mobile devices)
 * 2. OR just narrow viewport (desktop users resizing window)
 * 
 * This ensures narrow desktop windows get the mobile-optimized layout
 * (vertical chat resize, simplified UI)
 */
export function useDeviceDetection() {
  const [isMobile, setIsMobile] = useState(() => detectMobile());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(detectMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}

/**
 * Synchronous mobile detection function
 */
function detectMobile(): boolean {
  if (typeof window === 'undefined') return false;

  const isNarrowViewport = window.innerWidth <= MOBILE_BREAKPOINT;
  
  // Treat narrow viewports as mobile (better UX for narrow desktop windows)
  // Mobile layout has vertical chat resize which works better in narrow spaces
  return isNarrowViewport;
}
